/* eslint-env browser */
import * as React from 'react'

import {
  computeTargetURLWithParameter,
  insertURLParameter,
  removeURLParameter,
} from '../../../../common/client/url-manipulator'

const PropTypes = require('prop-types')
const classNames = require('classnames')

class GridFilter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isActive: false,
    }
    this.onValueChanged = this.onValueChanged.bind(this)
    this.getLink = this.getLink.bind(this)
    this.toggleIsActive = this.toggleIsActive.bind(this)
    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  onValueChanged(event, value) {
    event.preventDefault()
    const { onChange, changeURLQueryParam } = this.props

    if (changeURLQueryParam && changeURLQueryParam.length > 0) {
      if (!value || value === '__ALL__') {
        removeURLParameter(changeURLQueryParam)
      } else {
        insertURLParameter(changeURLQueryParam, value)
      }
    }

    this.setState(
      {
        isActive: false,
      },
      () => {
        onChange(value)
      }
    )
  }

  setWrapperRef(node) {
    this.wrapperRef = node
  }

  getLink(optionValue) {
    const { changeURLQueryParam, host, hostPath, otherQueryParams } = this.props
    const queryParams = { ...otherQueryParams }
    if (changeURLQueryParam && changeURLQueryParam.length > 0) {
      queryParams[changeURLQueryParam] = optionValue !== '__ALL__' ? optionValue : null
    }
    return computeTargetURLWithParameter({
      host,
      path: hostPath,
      queryParams,
    })
  }

  handleClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ isActive: false })
    }
  }

  toggleIsActive() {
    this.setState(prevState => ({
      isActive: !prevState.isActive,
    }))
  }

  render() {
    const { isActive } = this.state

    const { allLabel, label, options, buttonClassName } = this.props

    let { value } = this.props
    if (!value || value.length === 0) {
      value = '__ALL__'
    }

    let currentlySelected = options.find(elt => elt.value === value) || {}
    if (value === '__ALL__') {
      currentlySelected = { display: allLabel }
    }

    return (
      <div
        ref={this.setWrapperRef}
        className={classNames('dropdown is-right has-text-left has-margin-horizontal-small', { 'is-active': isActive })}
      >
        <div className="dropdown-trigger">
          <button
            className={classNames('button', buttonClassName)}
            type="button"
            aria-haspopup="true"
            aria-controls="dropdown-menu"
            onClick={this.toggleIsActive}
          >
            <span>{`${label || ''} ${(currentlySelected.display || '').trim()}`}</span>
            <span className="icon is-small">
              <i className="fas fa-angle-down" aria-hidden="true" />
            </span>
          </button>
        </div>
        <div className="dropdown-menu" id="dropdown-menu" role="menu">
          <div className="dropdown-content" style={{ maxHeight: 300, maxWidth: '90vh', overflowY: 'scroll' }}>
            {allLabel && (
              <a
                key="__ALL__"
                href={this.getLink('__ALL__')}
                className={classNames('dropdown-item', { 'is-active': value === '__ALL__' })}
                onClick={e => {
                  this.onValueChanged(e, '__ALL__')
                }}
              >
                {allLabel}
              </a>
            )}
            {options.map(option => (
              <a
                key={option.key}
                href={this.getLink(option.value)}
                className={classNames('dropdown-item', { 'is-active': option.value === value })}
                onClick={e => {
                  this.onValueChanged(e, option.value)
                }}
              >
                {option.display}
              </a>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

GridFilter.propTypes = {
  label: PropTypes.string,
  allLabel: PropTypes.string,
  options: PropTypes.array.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  changeURLQueryParam: PropTypes.string,
  host: PropTypes.string.isRequired,
  hostPath: PropTypes.string.isRequired,
  otherQueryParams: PropTypes.object,
  buttonClassName: PropTypes.string,
}

GridFilter.defaultProps = {
  label: null,
  allLabel: null,
  value: '__ALL__',
  changeURLQueryParam: null,
  otherQueryParams: {},
  buttonClassName: 'is-white has-text-link has-text-weight-bold is-small',
}

module.exports = GridFilter
